import { EditedRecord } from '@modules/feedback/store/types';
import { getReasonPredictions } from '@modules/feedback/utils/getReasonPredictions';
import { getSentimentPrediction } from '@modules/feedback/utils/getSentimentPrediction';
import { getTrackedKeywordPredictions } from '@modules/feedback/utils/getTrackedKeywordPredictions';

interface GetUpdatedEditedOptions {
  editedRecords: EditedRecord[];
  recordInEditMode: EditedRecord;
  existingEditedRecordIndex: number;
}

export const getUpdatedEditedRecords = ({
  editedRecords,
  recordInEditMode,
  existingEditedRecordIndex,
}: GetUpdatedEditedOptions): EditedRecord[] => {
  if (existingEditedRecordIndex < 0) {
    return [...editedRecords, recordInEditMode];
  }

  const editedRecord = editedRecords[existingEditedRecordIndex];

  const reasonPredictions = getReasonPredictions(recordInEditMode);
  const trackedKeywordPredictions =
    getTrackedKeywordPredictions(recordInEditMode);
  const sentimentPrediction = getSentimentPrediction(recordInEditMode);

  return [
    ...editedRecords.slice(0, existingEditedRecordIndex),
    {
      ...editedRecord,
      editPredictions: [
        ...(editedRecord.editPredictions ?? []),
        ...(reasonPredictions ?? []),
        ...(trackedKeywordPredictions ?? []),
        ...(sentimentPrediction ? [sentimentPrediction] : []),
      ],
    },
    ...editedRecords.slice(existingEditedRecordIndex + 1),
  ];
};
